import React, { useState, useRef, useEffect } from 'react';
import {
    Send,
    MoreVert,
    Phone,
    Videocam,
    Mic,
    EmojiEmotions,
    AttachFile
} from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import './FuturisticChat.scss';
import Popup from '../../../../presentationals/Popup/Popup.component'

import { getChatbotUserMessageByUserId, getChatbotMarkAllMessageByUserByUserId, SendchatbotMessageToUserById } from '../../../../containers/Admin/AdminActionCreator.component';

const ChatbotcustomTab = ({ handleOpenchatTab, chatTaboption, admin }) => {
    const [messagecount,setMessagecount] =useState(0)
    const [messages, setMessages] = useState([]);
    const [popup, setPopup] = useState({show:false,popusStatus:""});

    const [newMessage, setNewMessage] = useState("");
    const [isTyping, setIsTyping] = useState(false);
    const messagesEndRef = useRef(null);


    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

   
    useEffect(() => {
        const interval = setInterval(() => {
            getChatbotUserMessageByUserIdFunction(chatTaboption?.data);
        }, 6000);

        getChatbotUserMessageByUserIdFunction(chatTaboption?.data);
        return () => clearInterval(interval);
    }, [chatTaboption?.data]);

    const handleSendMessage = (e) => {
        e.preventDefault();
        if (newMessage.trim()) {
            const message = {
                "communityId": messages?.length > 0 ? messages?.[0]?.communityId : "",
                "userId": chatTaboption?.data?.userId,
                "comment": newMessage,
                "adminId": admin?.emailId,
                "createdBy": "ADMIN"
            };
            SendchatbotMessageToUserById(message, callback => {
                console.log("ca", callback)
                if(callback?.message == "success" && callback?.status == 200){
                    setNewMessage("");
                    getChatbotUserMessageByUserIdFunction(chatTaboption?.data)
                }else{
                    setPopup({show:true,popusStatus:'Message not Sent'})
                    removePopup()
                }
            })


        }
    };

    const formatTime = (timestamp) => {
        const date = new Date(timestamp);
        const now = new Date();

        const isToday =
            date.getDate() === now.getDate() &&
            date.getMonth() === now.getMonth() &&
            date.getFullYear() === now.getFullYear();

        if (isToday) {
            return date.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            });
        } else {
            return date.toLocaleDateString("en-GB") + " " + date.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            });
        }
    };

    const getInitials = (name) => {
        return name.split(" ").map(n => n[0]).join("");
    };

    const getChatbotUserMessageByUserIdFunction = (data) => {
        getChatbotUserMessageByUserId(data?.userId, callback => {
            console.log("cal", callback)
            if (callback?.message == "success" && callback?.status == 200) {
                const reversedData = callback?.data?.length > 0 ? callback?.data?.reverse() : [];
                setMessages(reversedData)
                getChatbotMarkAllMessageByUserByUserIdFunction(data)
                if(messagecount < reversedData?.length){
                    setMessagecount(reversedData?.length)
                    scrollToBottom();
                }
            } else {
                setMessages([])
            }
        })
    }
    const getChatbotMarkAllMessageByUserByUserIdFunction = (data) => {
        getChatbotMarkAllMessageByUserByUserId(data?.userId, "COMMUNITY", callback => {
            if (callback?.message == "success" && callback?.status == 200) {

            }

        })
    }

    const closePopup =()=>{
        setPopup({show:false,popusStatus:""})
    }

    const removePopup =()=>{
        setTimeout(()=>{
closePopup()
        },5000)
    }


    return (
        <>
        {
            popup?.show ?
            <Popup popupStatus={popup?.popusStatus} closePopup={closePopup}/>
       :'' }
        <div className='action-box animated slideInRight' >
            {/* <button onClick={() => handleOpenchatTab(false, '')} className='action-btn'>Action <i className='fa fa fa-chevron-down'></i> </button> */}
            <div className="chat-container-new">
                {/* Animated Light Background */}
                <div className="background-layer">
                    <div className="gradient-overlay"></div>
                    {/* <div className="floating-light light-1"></div>
                    <div className="floating-light light-2"></div>
                    <div className="floating-light light-3"></div> */}
                </div>

                <div className="chat-content">
                    {/* Header */}
                    <div className="header">
                        <div className="header-background"></div>
                        <div className="header-content">
                            <div className="user-info">
                                <div className="avatar-container">
                                    <div className="avatar">
                                        {getInitials(chatTaboption?.data?.firstName)}
                                    </div>
                                    {/* <div className="online-indicator"></div> */}
                                </div>
                                <div className="user-details">
                                    <h2 className="user-name">{chatTaboption?.data?.firstName}</h2>
                                    {/* <div className="status">
                                        <div className="status-dot"></div>
                                        <p className="status-text">Online • Active now</p>
                                    </div> */}
                                </div>
                            </div>
                            <div className="header-actions">
                                {/* <button className="action-button">
                                    <Videocam />
                                </button>
                                <button className="action-button">
                                    <Phone />
                                </button> */}
                                {/* <button className="action-button">
                                    <MoreVert />
                                </button> */}
                                <button className="action-button" onClick={() => handleOpenchatTab(false, '')}>
                                    <CloseIcon style={{ color: 'red' }} />
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Messages Area */}
                    <div className="messages-area">
                        {messages?.length > 0 && messages.map((message, index) => (
                            <div
                                key={message?.messageId}
                                className={`message-wrapper ${message?.createdBy == "ADMIN" ? 'own' : 'other'}`}
                                style={{ animationDelay: `${index * 100}ms` }}
                            >
                                <div className="message-container">
                                    {message?.createdBy == "COMMUNITY" && (
                                        <p className="sender-name">{chatTaboption?.data?.firstName || ""}</p>
                                    )}
                                    {message?.createdBy == "ADMIN" && (
                                        <p className="sender-name" style={{textAlign:'end',marginRight:'15px'}}>{message?.adminId || ""}</p>
                                    )}
                                    <div className={`message ${message?.createdBy == "ADMIN" ? 'own-message' : 'other-message'}`}>
                                        <p className="message-text">{message?.comment}</p>
                                        <div className="message-footer">
                                            <p className="message-time">{formatTime(message?.addedOn)}</p>
                                            {message?.createdBy == "ADMIN" && (
                                                <div className="read-indicators">
                                                    <div className="read-dot"></div>
                                                    <div className="read-dot"></div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="message-glow"></div>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {/* Typing Indicator
                        {isTyping && (
                            <div className="message-wrapper other typing-indicator">
                                <div className="message-container">
                                    <p className="sender-name">Alex Chen</p>
                                    <div className="message other-message">
                                        <div className="typing-dots">
                                            <div className="typing-dot"></div>
                                            <div className="typing-dot"></div>
                                            <div className="typing-dot"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )} */}

                        <div ref={messagesEndRef} />
                    </div>

                    {/* Input Area */}
                    <div className="input-area">
                        <div className="input-background"></div>
                        <div className="input-content">
                            <div className="input-form">
                                {/* <div className="input-actions">
                                    <button type="button" className="input-action-button">
                                        <AttachFile />
                                    </button>
                                    <button type="button" className="input-action-button">
                                        <EmojiEmotions />
                                    </button>
                                </div> */}

                                <div className="input-container" style={{ padding: '0' }}>
                                    <textarea
                                        type="text"
                                        placeholder="Type your message..."
                                        value={newMessage}
                                        onChange={(e) => setNewMessage(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleSendMessage(e);
                                            }
                                        }}
                                        className="message-input"
                                    />
                                    {/* <button type="button" className="mic-button">
                                        <Mic />
                                    </button> */}
                                </div>

                                <button
                                    type="button"
                                    onClick={handleSendMessage}
                                    className={`send-button ${!newMessage.trim() ? 'disabled' : ''}`}
                                    disabled={!newMessage.trim()}
                                >
                                    <Send />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default ChatbotcustomTab;